<main id="main-content" class="main-content">
    <div class="report-message">
        <mat-icon class="message-icon">check</mat-icon>
        <div class="message-text">
            <h1>Accomplishment Report has been Submitted to the Regional and Washington Office.</h1>
            <button class="usa-button"  [routerLink]="'/view-report-accomplishment'"
                    [queryParams]="{accomplishment_id: report()?.accomplishment_id}">View Accomplishment Report</button>
        </div>
    </div>
</main>